import Spinner from "components/view/loader";

interface HistoryRpsShowProps {
  Status?: string | undefined;
  Name?: string | undefined;
  Amount?: number | undefined;
  Time?: string | undefined;
  Color?: string | undefined;
  loading?: boolean | undefined;
}

export default function HistoryRpsShow(props: HistoryRpsShowProps) {
  return (
    <div className="container card color-font-card shadow">
      <div className="heading margin-left-10">
        <div className="row">
          <div className="col-6">
            <div>
              <h4>
                <span>{props.Name}</span>{" "}
              </h4>
            </div>
          </div>
        </div>
        <div className="bottom-line-yellow margin-bottom-10"></div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-6 margin-top-3">
            เดิมพัน {`${(props.Amount ?? 0) * -1} uDiamond`}
          </div>
          <div className="text-right col-6">
            <h4>
              <Spinner></Spinner> <span>รอผู้ท้าประลอง</span>
            </h4>
          </div>
          <div className="col-6 margin-top-3"></div>
          <div className="text-right col-6">{props.Time}</div>
        </div>
      </div>
    </div>
  );
}
